import * as React from "react";
import useSWR from "swr";
import fetcher from "./fetcher";

const baseEndpoint = "/api/talentDashboard/getPaidV2/eligible-items";

export default function useGetPaidEligibleItems(
  influencerId,
  shouldFetch = false,
) {
  const url = React.useMemo(() => {
    if (!shouldFetch) return null;
    const params = new URLSearchParams();
    if (influencerId) {
      params.set("influencer_id", String(influencerId));
    }
    const qs = params.toString();
    return qs ? `${baseEndpoint}?${qs}` : baseEndpoint;
  }, [influencerId, shouldFetch]);

  const { data, error, mutate } = useSWR(url, fetcher);

  return {
    items: data?.items ?? [],
    total: data?.total ?? 0,
    isLoading: shouldFetch && !data && !error,
    error,
    refresh: mutate,
  };
}
